const MAX_LENGTH = 10;

export function randomString(length) {
  length = length || MAX_LENGTH;

  if (!Number.isInteger(length) || length > MAX_LENGTH || length < 1) {
    throw `length must be between 1 - ${MAX_LENGTH}`;
  }

  return Math.random()
    .toString(36)
    .substring(2, 2 + length);
}
